// extracted by mini-css-extract-plugin
export default {"iconContainer":"v61uueDZ4BvK66T2u1Qi","iconBackground":"uE9ZfNrCmr6jO4j4v12w","iconCircle":"yM9Z6D3oQm2Zm7nejQxk","icon":"vTptzesg62Mzz6hsxLT8"};